import React, { useEffect, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useRouter from 'common/hooks/use-router';
import AlertsContext from 'common/contexts/alerts';
import useFurniture from 'furnitures/contexts/furnitures';

import PageHeader from 'common/components/PageHeader/PageHeader';
import PageLoader from 'common/components/PageLoader/PageLoader';
import FurnitureForm from './FurnitureForm';

const FurnitureFormPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);
  const {
    save, update, fetchItem, item: furniture, isFetching,
  } = useFurniture();

  const { id: furnitureId } = router.match.params;

  useEffect(() => { fetchItem(furnitureId); }, [fetchItem, furnitureId]);

  const onSubmit = useCallback(async (furniture) => {
    if (furniture.id) {
      const res = await update(furniture.id, furniture);

      if (!res.error) {
        setAlert(t('furnitures.successEdit'), 'success');
        router.push('/furnitures');
      } else {
        setAlert(res.message, 'danger');
      }
    } else {
      const res = await save(furniture);

      if (!res.error) {
        setAlert(t('furnitures.successAdd'), 'success');
        router.push('/furnitures');
      } else {
        setAlert(res.message, 'danger');
      }
    }
  }, [router, update, save, setAlert, t]);

  return (
    <>
      <PageLoader processing={isFetching} />
      <PageHeader
        title={t(`furnitures.furniture${furniture && furniture.id ? 'Edit' : 'Add'}`)}
        subLink={{ url: '/furnitures', icon: 'arrow-left', label: t('common.back') }}
      />
      <section className="section form-page">
        <FurnitureForm
          onSubmit={onSubmit}
          furniture={furniture}
        />
      </section>
    </>
  );
};

export default FurnitureFormPage;
